import { Container, Grid, Link } from "@mui/material";
import React, { useState , useEffect, useRef } from "react";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import Web3 from "web3";

import DashboardMenuForDesktop from "../../../Components/Menu/DashboardMenu";

import ConnectScreen from "../Login/connectscreen";
import ErroBook from "../../../Components/ErroBook/ntErro"
import Loader from "../../../Components/ErroBook/loader"

import logo from "../../../images/logo.png"
import playtable_half from "../../../images/playtable_half.png"
import swapImg from "../../../images/swap.png"


import snoonerIcon from "./../../../images/snooner-icon.png"
import inGameIcon from "./../../../images/in-game-icon.png"
import playerIcon from "./../../../images/player-icon.png"
import graph from "./../../../images/graph.png"
import TopWinning from "../../../Components/TopWinningCard";

import BarChart from 'react-bar-chart';

var web3;
var deciConvert = 1e18;
var msAdd;
var msAbi;
var msContract
var swapAdd;
var swapAbi;
var swapContract
let appID = 'cf4363b024a1a9a2991ff2e7571ddcef';
let historyData = [];
let topWiningTable = [];
    
const DashboadScreen = () => {
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [useSwapForm, setSwapForm] = useState(false);
    const [useApproveBTN, setApproveBTN] = useState(true);
    const [useMetaAmount, setMetaAmount] = useState('');
    const [useMetaInGameAmount, setMetaInGameAmount] = useState('');
    const [useMetaAmountError, setMetaAmountError] = useState(false);
    const [useInGameAmount, setInGameAmount] = useState('');
    const [useInGameMetaAmount, setInGameMetaAmount] = useState('');
    const [useInGameAmountError, setInGameAmountError] = useState(false);
    const [useInGameRate, setInGameRate] = useState('0');
    const [useWalletConnected, setWalletConnected] = useState(false);
    const [usePlayedGame, setPlayedGame] = useState('0');
    
    
    

    // wallet related states
    const [useWalletAddress, setWalletAddress] = useState('0x');
    const [useUserMetaBalance, setUserMetaBalance] = useState('0');
    const [useMetaTokenBalance, setMetaTokenBalance] = useState('0');
    const [useUserInGameBalance, setUserInGameBalance] = useState('0');
    const [useInGameTokenBalance, setInGameTokenBalance] = useState('0');
    const [useError, setError] = useState(false);
    const [useErrorType, setErrorType] = useState('a');
    const [useLoader, setLoader] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        // console.log('width', ref.current ? ref.current.offsetWidth : 0);
    }, [ref.current]);

    const data = [
        {text: 'jan', value: 100}, 
        {text: 'Feb', value: 10}, 
        {text: 'Mar', value: 50}, 
        {text: 'Apr', value: 200}, 
        {text: 'May', value: 55}, 
        {text: 'Jun', value: 250}, 
        {text: 'Jul', value: 100} 
      ];
       
      const margin = {top: 20, right: 20, bottom: 30, left: 40};
 
      


    const handleInputSwap = (event, newFormats) => {
        setInGameAmount('')
        setMetaAmount('')
        setMetaAmountError(false)
        setInGameAmountError(false)
        if (newFormats == '') {
            setSwapForm(false);
        } else {
            setSwapForm(newFormats);
        }
    };


    useEffect(()=> {
            if( localStorage.getItem("token") == "" || localStorage.getItem("token") == null ){
                window.location.replace("/login");
            }
            connectWallet();
            setTimeout(() => {
                setError(false)
            }, 5000)

    },[useWalletConnected, useWalletAddress]);
    useEffect(()=> {
            fetch('https://metasnooker.herokuapp.com/api/auth/app_id=' + appID + '/findone/' + localStorage.getItem("userDbAddress"), {
                method: "GET",
                headers: {"Authorization": `Bearer `+ localStorage.getItem("token") }
            }).then(jsonData => {
                jsonData.json().then(data => {
                    console.log("History: ",data)
                    historyData = [
                        data.map( ( i, j ) => {
                            setPlayedGame(j+1)
                            let playingStated  = <span className=""></span>;
                            // {i.result==1 ? <span className="win">Win</span> : <span className="loss">Loss</span>}
                            if (i.result==1) {
                                playingStated = <span className="win">Win</span>;
                            } else if (i.result==0) {
                                playingStated = <span className="loss">Loss</span>;
                            }else {
                                playingStated = <span className="reverted">Reverted</span>;
                            }
                            return(
                            <TableRow>
                                <TableCell className="text-center" style={{minWidth: 20}} >
                                    {j+1}
                                </TableCell>
                                <TableCell className="text-left" style={{minWidth: 100}} >
                                    {conciseWallet(i.address)}
                                </TableCell>
                                <TableCell className="text-left" style={{minWidth: 100}} >
                                    {i.gameId}
                                </TableCell>
                                <TableCell className="text-center" style={{minWidth: 50}} >
                                    {i.challengeprice}
                                </TableCell>
                                <TableCell className="text-center" style={{minWidth: 70}} >
                                    {playingStated}
                                </TableCell>
                                <TableCell className="text-center" style={{minWidth: 100}} >
                                    {dateformate(i.updatedAt)}
                                </TableCell>
                            </TableRow>
                            )
                        })
                    ]
                })
            });
            fetch('https://metasnooker.herokuapp.com/api/auth/app_id=' + appID + '/findTopfive/' + localStorage.getItem("userDbAddress"), {
                method: "GET",
                headers: {"Authorization": `Bearer `+ localStorage.getItem("token") }
            }).then(jsonData => {
                jsonData.json().then(data => {
                    // console.log("Data: ",data)
                    topWiningTable = [
                        data.map( ( i, j ) => {
                            return(
                                <TopWinning 
                                    position = {j+1}
                                    customClass = {"a"}
                                    address = {conciseWallet(i.address)}
                                    duration = {timeSince(new Date(i.updatedAt))}
                                    amount = {i.challengeprice}
                                />
                            )
                        })
                    ]
                })
            });
        },[])
        const dateformate = (val) => {
            var date_old = new Date(val).getTime()
            var date = new Date(date_old)
            return date.toLocaleString('en-US')
        }
        const timeSince = (val) => {
            var date_old = new Date(val).getTime()
            var date_today = Date.now()
            var date = new Date(date_old)
            // var date;
            var seconds = Math.floor((new Date() - date) / 1000);
          
            var interval = seconds / 31536000;
          
            if (interval > 1) {
              return Math.floor(interval) + " years";
            }
            interval = seconds / 2592000;
            if (interval > 1) {
              return Math.floor(interval) + " months";
            }
            interval = seconds / 86400;
            if (interval > 1) {
              return Math.floor(interval) + " days";
            }
            interval = seconds / 3600;
            if (interval > 1) {
              return Math.floor(interval) + " hours";
            }
            interval = seconds / 60;
            if (interval > 1) {
              return Math.floor(interval) + " minutes";
            }
            return Math.floor(seconds) + " seconds";
          }

    /***************************************************
    *
    *    Handle web3 integration in DApp
    *    1=> amountFormate 
    *        a) set amount comma 
    *        b) set humber of digit after decimal
    *  
    *    2=> conciseWallet
    *        This function is used to hide half wallet address
    *        (i.e. 0xabc....zyx)
    * 
    *    3=> chainChanged
    *        This is ethereum function from web3, used to handle
    *        in changing NETWORK from metamask 
    * 
    *    4=> accountsChanged
    *        This is ethereum function from web3, used to handle
    *        in changing USER-WALLET-ADDRESS from metamask 
    *    
    *    5=> connectWallet
    *        This function is used to deal with contract(s)
    *        (i.e. getting/sending values from/in the contract(s)
    *        It will call when page reload and also on click
    * 
    *
    ****************************************************/
    // 1=> numaricAmount
    const amountFormate = (num,digit) => {
        var testnumber = Number.parseFloat(num).toFixed(digit);
        return testnumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    // 2=> conciseWallet
    const conciseWallet = (value) => {
        const intvalue = value.toString();
        if( intvalue != ""){
            const start_char = value.toString().substring(0,6)+"***";
            const end_char = value.toString().substr(value.length - 4);
            return (start_char + end_char)
        }
    }

    // 3=> chainChanged
    window.ethereum.on('connect',  ( _connectInfo => {
        // BSC 0x38
        // BSCTestnet 0x61
        if ( _connectInfo.chainId != "0x38") {
            setErrorType('wrongNetwork')
            setError(true)
        }
    }));
    window.ethereum.on('chainChanged', (_chainId => {
        // BSC 0x38
        // BSCTestnet 0x61
        if ( _chainId == "0x38") {
            window.location.reload();
        }else{
            setLoader(true)
            setErrorType('wrongNetwork')
            setError(true)
        }
    }));
    // 4=> accountsChanged
    try {
        window.ethereum.on('accountsChanged', ( _mAddress => {
            if( _mAddress != "" ){
                setErrorType('walletChanged');
                setError(true);
                window.location.reload();
            }else{
                setWalletConnected(false)
                setErrorType('walletNotConnected')
                setLoader(false)
                setError(true)
            }
        }));
    } catch (error) {
        console.log('Address: ', error)
    }

    // 5=> connectWallet
    const connectWallet = () => {
        if(typeof Web3 !== 'undefined'){

            web3 = new Web3(window.ethereum);
            try {
                window.ethereum.request({ method: 'eth_chainId' }).then( _chainId => {
                    // BSC 0x38
                    // BSCTestnet 0x61
                    if ( _chainId != "0x38") {
                        setLoader(true)
                        setErrorType('wrongNetwork')
                        setError(true)
                    }
                })
            } catch (error) {
                console.log(error)
            }

            //MetaSnooker contract 
            msAdd = "0xBa8d9B8F138EE5269A5C23339775510D050b75C1";
            msAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"bool","name":"isExcluded","type":"bool"}],"name":"ExcludeFromFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address[]","name":"accounts","type":"address[]"},{"indexed":false,"internalType":"bool","name":"isExcluded","type":"bool"}],"name":"ExcludeMultipleAccountsFromFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"newValue","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"oldValue","type":"uint256"}],"name":"GasForProcessingUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newLiquidityWallet","type":"address"},{"indexed":true,"internalType":"address","name":"oldLiquidityWallet","type":"address"}],"name":"LiquidityWalletUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"iterations","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"claims","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lastProcessedIndex","type":"uint256"},{"indexed":true,"internalType":"bool","name":"automatic","type":"bool"},{"indexed":false,"internalType":"uint256","name":"gas","type":"uint256"},{"indexed":true,"internalType":"address","name":"processor","type":"address"}],"name":"ProcessedDividendTracker","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"tokensSwapped","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"maticRewards","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"buyBack","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"marketing","type":"uint256"}],"name":"SendDividends","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"pair","type":"address"},{"indexed":true,"internalType":"bool","name":"value","type":"bool"}],"name":"SetAutomatedMarketMakerPair","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokensSwapped","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethReceived","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokensIntoLiqudity","type":"uint256"}],"name":"SwapAndLiquify","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"bool","name":"enabled","type":"bool"}],"name":"SwapAndLiquifyEnabledUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"amountIn","type":"uint256"},{"indexed":false,"internalType":"address[]","name":"path","type":"address[]"}],"name":"SwapETHForTokens","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newAddress","type":"address"},{"indexed":true,"internalType":"address","name":"oldAddress","type":"address"}],"name":"UpdateDividendTracker","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newAddress","type":"address"},{"indexed":true,"internalType":"address","name":"oldAddress","type":"address"}],"name":"UpdateUniswapV2Router","type":"event"},{"inputs":[],"name":"BNBRewardsFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"automatedMarketMakerPairs","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"buyBackFees","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"cooldownEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cooldownTime","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"deadAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"dividendTokenBalanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"dividendTracker","outputs":[{"internalType":"contract MetaDividendTracker","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bool","name":"excluded","type":"bool"}],"name":"excludeFromFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address[]","name":"accounts","type":"address[]"},{"internalType":"bool","name":"excluded","type":"bool"}],"name":"excludeMultipleAccountsFromFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"gasForProcessing","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getAccountDividendsInfo","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getAccountDividendsInfoAtIndex","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getClaimWait","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLastProcessedIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNumberOfDividendTokenHolders","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getTotalDividendsDistributed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isExcludedFromFees","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"liquidityFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"liquidityWallet","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"marketingFees","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxSellTransactionAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"gas","type":"uint256"}],"name":"processDividendTracker","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"sellFeeIncreaseFactor","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"pair","type":"address"},{"internalType":"bool","name":"value","type":"bool"}],"name":"setAutomatedMarketMakerPair","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"value","type":"bool"}],"name":"setCooldownEnabled","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"}],"name":"setCooldownTime","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"}],"name":"setMaxSellTransactionAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"_enabled","type":"bool"}],"name":"setSwapAndLiquifyEnabled","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"swapAndLiquifyEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"swapTokensAtAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalFees","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"uniswapV2Pair","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"uniswapV2Router","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"claimWait","type":"uint256"}],"name":"updateClaimWait","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newAddress","type":"address"}],"name":"updateDividendTracker","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newValue","type":"uint256"}],"name":"updateGasForProcessing","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newLiquidityWallet","type":"address"}],"name":"updateLiquidityWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newAddress","type":"address"}],"name":"updateUniswapV2Router","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"withdrawableDividendOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"stateMutability":"payable","type":"receive"}]
            msContract = new web3.eth.Contract( msAbi , msAdd );

            //Swap contract 
            // swapAdd = "0x44914Aa019Eb13C85f2e524e6A1eC30c904ea85E"; // old swap Contract
            swapAdd = "0xd456bb4233f8864fec44dbe7f11390d17556420e";
            swapAbi = [{"inputs":[{"internalType":"address","name":"meta","type":"address"},{"internalType":"address","name":"_tax_distribution","type":"address"},{"internalType":"uint256","name":"_tax_rate","type":"uint256"},{"internalType":"uint256","name":"_conversion_rate","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPulled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPushed","type":"event"},{"inputs":[],"name":"conversion_rate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"failsafe","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"ingame_swapped","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"manager","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"meta_swapped","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pullManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner_","type":"address"}],"name":"pushManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"}],"name":"recoverLostToken","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"identifier","type":"string"}],"name":"register","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"","type":"string"}],"name":"registered_data","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"registered_users","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"removeFailsafe","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_rate","type":"uint256"}],"name":"setConversionRate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"setFailsafe","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_rate","type":"uint256"}],"name":"setTaxRate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"setTaxWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"}],"name":"swapInGame","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"}],"name":"swapMeta","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"tax_rate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"}]
            swapContract = new web3.eth.Contract( swapAbi , swapAdd );

            // CG API call handle to get token price
            // fetch('https://api.coingecko.com/api/v3/coins/cardano').then(jsonData => {
            //     jsonData.json().then(data => {
            //         console.log('Price API' , data)
            //     })
            // });

            //get connected wallet address
            try {
                window.ethereum.request({ method: 'eth_requestAccounts'}).then( _account => {
                    conciseWallet(_account.toString());
                    setWalletConnected(true)
                    let userWalletAdd = _account.toString()
                    if ( localStorage.getItem("userDbAddress") != userWalletAdd) {
                        handleLogout()
                    } else {
                        setWalletAddress(userWalletAdd)
                        fetch('https://metasnooker.herokuapp.com/api/auth/app_id=' + appID + '/findoneuser/' + _account.toString(), {
                            method: "GET",
                            headers: {"Authorization": `Bearer `+ localStorage.getItem("token") }
                        }).then(jsonData => {
                            jsonData.json().then(data => {
                                if(data.length !== 0){
                                    setInGameTokenBalance(data[0].inGametoken)
                                    setUserInGameBalance(amountFormate(data[0].inGametoken,2))
                                }
                            })
                        });

                        msContract.methods.balanceOf(_account.toString()).call().then( result => {
                            setMetaTokenBalance(result/deciConvert)
                            setUserMetaBalance(amountFormate(result/deciConvert,2))
                            
                        })
                        msContract.methods.allowance(_account.toString(),swapAdd).call().then( result => {
                            if( result > 1 ){
                            setApproveBTN(false)
                            }else{
                            setApproveBTN(true)
                            }   
                            setLoader(false)     
                        })
                        swapContract.methods.conversion_rate().call().then( result => {
                            setInGameRate(result)
                        })  
                    }
                })
                .catch (error => {
                    setErrorType('walletNotConnected')
                    setError(true)
                });
            } catch (error) {
                setErrorType('noMetamask')
                setError(true)
            }
        }else{
            console.log('Please install metamask to use this page.!')
        }
    }
    
    const handleApprove = () => {
        // setLoader('block');
        setLoader(true)
        msContract.methods.approve(swapAdd, '115792089237316195423570985008687907853269984665640564039457584007913129639935')
        .send({from: useWalletAddress}).then( test => {
            msContract.methods.allowance(useWalletAddress,swapAdd).call().then( result => {
            if( result > 1 ){
              setApproveBTN(false)
            }else{
              setApproveBTN(true)
            }   
            setLoader(false)     
          })
        })
        .catch(error => {
            setLoader(false)
          console.log('Getting Errors: ' , error);
        });
    }
    
    const handleMetaAmount = (val,type) => {
        setMetaAmountError(false)
        let inputValue = val.target.value;
        let expectedIngame = useInGameRate * inputValue;
        if( type == 'metaInput'){
            setMetaAmount(inputValue)
            setInGameAmount(expectedIngame)
            if(inputValue > useMetaTokenBalance){
                setMetaAmountError(true)
            }else if(inputValue <= 0){
                setMetaAmountError(true)
            }else{
                setMetaAmountError(false)
            }
        }else if( type == 'inGameInput'){
            let convertedMeta = inputValue / useInGameRate
            setMetaAmount(convertedMeta)
            setInGameAmount(inputValue)
            if(convertedMeta > useMetaTokenBalance){
                setMetaAmountError(true)
            }else if(inputValue <= 0){
                setMetaAmountError(true)
            }else{
                setMetaAmountError(false)
            }
        }else {
            setMetaAmount(val)
            if(val > useMetaTokenBalance){
                setMetaAmountError(true)
            }else if(val <= 0){
                setMetaAmountError(true)
            }else{
                setMetaAmountError(false)
            }
        }
    }

    const handleInGameAmount = (val,type) => {
        setInGameAmountError(false)
        let inputValue = val.target.value;
        let convertedMeta = inputValue / useInGameRate;
        if( type == 'inGameInput'){
            setInGameAmount(inputValue)
            setMetaAmount(convertedMeta)
            if(parseFloat(inputValue) > parseFloat(useInGameTokenBalance)){
                setInGameAmountError(true)
            }else if(inputValue <= 0){
                setInGameAmountError(true)
            }else{
                setInGameAmountError(false)
            }
        }else if( type == 'metaInput'){
            let expectedIngame = useInGameRate * inputValue;
            setInGameAmount(expectedIngame)
            setMetaAmount(inputValue)
            if(expectedIngame > useInGameTokenBalance){
                setInGameAmountError(true)
            }else if(inputValue <= 0){
                setInGameAmountError(true)
            }else{
                setInGameAmountError(false)
            }
        }else{
            setInGameAmount(val)
            // if(val > useInGameTokenBalance){
            //     setInGameAmountError(true)
            // }else if(val <= 0){
            //     setInGameAmountError(true)
            // }else{
            //     setInGameAmountError(false)
            // }
        }
    }

    const sumup = (a,b) => {
        let sum = a+b;
        return sum;
    }
    const handleGetInGameSwap = () => {
        if (useMetaAmount == "" || useMetaAmount <= 0.01 || isNaN(useMetaAmount)){
            setMetaAmountError(true)
            return;
        }
        if(parseFloat(useMetaAmount) > parseFloat(useMetaTokenBalance)){
            setMetaAmountError(true)
            return;
        }else if(useMetaAmount <= 0){
            setMetaAmountError(true)
            return;
        }
        if (useInGameAmount == "" || useInGameAmount <= 0.01 || isNaN(useInGameAmount)){
            setInGameAmountError(true)
            return;
        }
        setLoader(true)
        // Reserve MetaSnooker in contract and get inGame tokens
        let inGameConvert = useInGameRate * useMetaAmount
        let addInGame = parseInt(useInGameTokenBalance) + parseInt(inGameConvert)
        let convertedamounttostr1 = useMetaAmount.toString()
        let convertedamounttostr = web3.utils.toWei(convertedamounttostr1, 'ether')
        
        swapContract.methods.swapMeta(convertedamounttostr)
            .send({from: useWalletAddress})
            .then( participateResult => {
                // console.log("transection blockHash: ", participateResult.blockHash)
                // console.log("transection status: ", participateResult.status)
                fetch('https://metasnooker.herokuapp.com/api/auth/app_id=' + appID + '/update/' + localStorage.getItem("userId"), {
                    method: "PUT",
                    headers: {
                        "Authorization": `Bearer `+ localStorage.getItem("token"),
                        "Content-type": "application/json; charset=UTF-8"
                    },
                    body: JSON.stringify({
                        'address': useWalletAddress,
                        'inGametoken': addInGame,
                    }) 
                }).then(jsonData => {
                    jsonData.json().then(data => {
                        console.log('update API' , data)
                        window.location.reload();
                    })
                });
        }).catch( error => {
            if( error.code == 4001){
                setLoader(false)
                setErrorType('metamaskReject')
                setError(true)
            }
        })
        
    }
    const handleGetMetaSwap = () => {
        if (useInGameAmount == "" || useInGameAmount <= 0.01 || isNaN(useInGameAmount)){
            setInGameAmountError(true)
            return;
        }
        if(parseFloat(useInGameAmount) > parseFloat(useInGameTokenBalance)){
            setInGameAmountError(true)
            return;
        }else if(useInGameAmount <= 0){
            setInGameAmountError(true)
            return;
        }
        if (useMetaAmount == "" || useMetaAmount <= 0.01 || isNaN(useMetaAmount)){
            setInGameAmountError(true)
            return;
        }
        if(useMetaAmount > useMetaTokenBalance){
            setInGameAmountError(true)
            return;
        }else if(useMetaAmount <= 0){
            setInGameAmountError(true)
            return;
        }
        
        
        // Release MetaSnooker from contract and remove inGame tokens
        setLoader(true)
        let inGameConvert = useInGameRate * useMetaAmount
        let subInGame = parseFloat(useInGameTokenBalance)-parseFloat(useInGameAmount)+0.0001

        let convertedamounttostr1 = useInGameAmount.toString()
        let convertedamounttostr = web3.utils.toWei(convertedamounttostr1, 'ether')
        
        // console.log("user Test", inGameConvert + " : " + subInGame + " : " + convertedamounttostr)
        swapContract.methods.swapInGame(convertedamounttostr)
            .send({from: useWalletAddress})
            .then( participateResult => {
                fetch('https://metasnooker.herokuapp.com/api/auth/app_id=' + appID + '/update/' + localStorage.getItem("userId"), {
                    method: "PUT",
                    headers: {
                        "Authorization": `Bearer `+ localStorage.getItem("token"),
                        "Content-type": "application/json; charset=UTF-8"
                    },
                    body: JSON.stringify({
                        'address': useWalletAddress,
                        'inGametoken': subInGame,
                    }) 
                }).then(jsonData => {
                    jsonData.json().then(data => {
                        // console.log('update API' , data)
                        window.location.reload();
                    })
                });
        })
        .catch( error => {
            if( error.code == 4001){
                setLoader(false)
                setErrorType('metamaskReject')
                setError(true)
            }else{
                setLoader(false)
                setErrorType('someThingelse')
                setError(true)
            }
        });
        
    }
    const handleLogout = () => {
        // console.log('User has been logd: ', localStorage.getItem("token") )
        localStorage.clear();
        setError(true)
        // console.log('User has been logd: ', localStorage.getItem("token") )
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    
    const columns = [
        { id: 'no', label: 'No.', minWidth: 20, align: 'center', },
        { id: 'player', label: 'Player', minWidth: 100 },
        {
            id: 'gameId',
            label: 'Game Id',
            minWidth: 50,
            align: 'center',
            format: (value) => value.toLocaleString('en-US'),
        },
        {
          id: 'challengeprize',
          label: 'Challenge Prize',
          minWidth: 50,
          align: 'center',
          format: (value) => value.toLocaleString('en-US'),
        },
        {
          id: 'result',
          label: 'Result',
          minWidth: 70,
          align: 'center',
          format: (value) => value.toLocaleString('en-US'),
        },
        {
          id: 'datetime',
          label: 'Date/Time',
          minWidth: 100,
          align: 'center',
          format: (value) => value.toFixed(2),
        },
      ];
      function createData(player, challengeprize, result, datetime) {
        return { player, challengeprize, result, datetime };
      }

    const userValidate = (val) => {
        if(val != "" || val != null){
            return val.substring(0, val.lastIndexOf("@") )
        }
    }
    return(
        <div className="MS---dashboard position-relative">
            {useError ?
                <ErroBook 
                    errorType = {useErrorType}
                />
            :
                <span />
            }
            { useLoader ? 
                <Loader />
                :
                <span />
            }
            { useWalletConnected ?
                <Grid 
                    container
                    justifyContent="flex-start"
                    className="AppDapp Dashboard position-relative py-3 px-1 px-sm-3"
                >
                    <DashboardMenuForDesktop />
                    <Grid md={2} />
                    <Grid 
                        container
                        xs={12}
                        md={10} 
                        className="MS--mainScreen py-4 px-4 px-sm-0"
                        alignContent="flex-start"
                        justifyContent="flex-start"
                    >
                        <Grid
                            xs={12}
                            className="text-left pb-0 px-lg-4 pl-sm-4"
                        >
                            <h4 className="text-capitalize">
                                Hello, {userValidate(localStorage.getItem("email"))}
                            </h4>
                            <p>Connected: {conciseWallet(localStorage.getItem("userDbAddress"))}</p>
                        </Grid>
                        <Grid 
                            container
                            xs={12}
                            md={12}
                            lg={8}
                            alignContent="flex-start"
                            justifyContent="flex-start"
                        >
                        
                            <Grid
                                xs={12}
                                sm={6}
                                md={4}
                                className="px-2 pl-sm-4 pr-sm-2 pr-lg-2"
                            >
                                <div className="MS---dapp_metaBalance mt-4 mt-lg-0 text-left px-4 px-sm-3 py-4">
                                    <h5 className="d-flex">
                                        <img src={snoonerIcon} className="img-fluid mt-1 mr-2" style={{width:30, height: 30}} />
                                        <span className="d-inline-block">
                                            MetaSnooker Balance
                                        </span>
                                    </h5>
                                    <h5 className="mb-0 mt-3 blue">{useUserMetaBalance} MSF</h5>
                                </div>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={6}
                                md={4}
                                className="px-2 pr-sm-4 pr-md-2 px-lg-3"
                            >
                                <div className="MS---dapp_IGBalance mt-4 mt-lg-0 text-left px-4 px-sm-3 py-4">
                                    <h5 className="d-flex">
                                        <img src={inGameIcon} className="img-fluid mt-1 mr-2" style={{width:30, height: 30}} />
                                        <span className="d-inline-block">
                                            In-Game Coins Balance
                                        </span>
                                    </h5>
                                    <h5 className="mb-0 mt-3 yellow">{useUserInGameBalance} IMSF</h5>
                                </div>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={6}
                                md={4}
                                className="px-2 pr-sm-4 pl-sm-2 pl-lg-3 d-none d-md-block"
                            >
                                <div className="MS---dapp_POBalance mt-4 mt-lg-0 text-left px-4 px-sm-3 py-4">
                                    <h5 className="d-flex">
                                        <img src={playerIcon} className="img-fluid mt-1 mr-2" style={{width:30, height: 30}} />
                                        <span className="d-inline-block">
                                            Total Matches Played
                                        </span>
                                    </h5>
                                    <h5 className="mb-0 mt-3 green">{usePlayedGame}</h5>
                                </div>
                            </Grid>
                            <Grid
                                xs={12}
                                className="px-sm-4"
                            >
                                <div className="MS---dapp_form MS---dapp_card text-left mt-4">
                                    <h3 className="mb-0 px-5 py-3">MetaSnooker Swap</h3>
                                    
                                    { useSwapForm ?
                                    
                                        <form className="text-center MS-dashboard-form swap py-4 mx-auto px-4" style={{maxWidth: 400}}>
                                            <div className="mb-2" style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <p className="mb-0 d-inline-block">
                                                In-Game Coins
                                                </p>
                                                <p className="mb-0 d-inline-block">
                                                    Balance : {useUserInGameBalance}
                                                </p>
                                            </div>
                                            <label className="position-relative">
                                                <input 
                                                    type='number' 
                                                    placeholder="In-game amount"
                                                    value={useInGameAmount}
                                                    onChange={(event,type) =>handleInGameAmount(event,'inGameInput')}
                                                />
                                                {useInGameAmountError ? 
                                                <p 
                                                    className="position-absolute mb-0 ml-sm-2 text-left text-danger"
                                                    style={{fontSize: 13, bottom: '-20px'}}
                                                >
                                                    Invalid amount entered.
                                                </p>
                                                :
                                                    <span />
                                                }
                                            </label>
                                            <ToggleButtonGroup
                                                value={useSwapForm}
                                                onChange={handleInputSwap}
                                                aria-label="Swap"
                                                className="MS---Swap_button_toggle"
                                            >
                                                <ToggleButton value="true" aria-label="Swap" style={{broder:0,boxShadow:0}}>
                                                    <span class="material-icons">swap_vert</span>
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                            <div className="m-nt-2 mb-2" style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <p className="mb-0 d-inline-block">
                                                    MetaSnooker
                                                </p>
                                                <p className="mb-0 d-inline-block">
                                                    Balance : {useUserMetaBalance}
                                                </p>
                                            </div>
                                            <label className="position-relative">
                                                <input 
                                                    type='number' 
                                                    placeholder="Metasnooker amount"
                                                    value={useMetaAmount}
                                                    onChange={(event,type) =>handleInGameAmount(event,'metaInput')}
                                                />
                                                {useMetaAmountError ? 
                                                <p 
                                                    className="position-absolute mb-0 ml-sm-2 text-left text-danger"
                                                    style={{fontSize: 13, bottom: '-20px'}}
                                                >
                                                    Invalid amount entered.
                                                </p>
                                                :
                                                    <span />
                                                }
                                            </label>
                                            {/* <input 
                                                type='number' 
                                                placeholder="Metasnooker amount"
                                                value={useMetaAmount}
                                                onChange={(event,type) =>handleMetaAmount(event,'srch')}
                                            /> */}
                                            <div className="mt-3 mb-2 px-2" style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <p className="mb-0 d-inline-block" style={{fontSize: 12}}>
                                                    Price
                                                </p>
                                                <p className="mb-0 d-inline-block" style={{fontSize: 12}}>
                                                    {1/useInGameRate} per In-Game
                                                </p>
                                            </div>
                                            { useApproveBTN ?
                                                <button
                                                    type="button"
                                                    className="MS---Neon--Button btn mt-4 mb-4 mr-3"
                                                    onClick={handleApprove}
                                                >
                                                    Approve
                                                </button>
                                            :
                                                <button
                                                    type="button" 
                                                    className="MS---Neon--Button btn mt-4 mb-4 mr-3"
                                                    onClick={ ( e ) => handleGetMetaSwap()}
                                                >
                                                    Get MetaSnooker
                                                </button>
                                            }
                                        </form>
                                        :
                                        <form className="text-center MS-dashboard-form swap py-4 mx-auto px-4" style={{maxWidth: 400}}>
                                            <div className="mb-2" style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <p className="mb-0 d-inline-block">
                                                    MetaSnooker
                                                </p>
                                                <p className="mb-0 d-inline-block">
                                                    Balance : {useUserMetaBalance}
                                                </p>
                                            </div>
                                            <label className="position-relative">
                                                <input 
                                                    type='number' 
                                                    placeholder="Metasnooker amount"
                                                    value={useMetaAmount}
                                                    onChange={(event,type) =>handleMetaAmount(event,'metaInput')}
                                                />
                                                {useMetaAmountError ? 
                                                <p 
                                                    className="position-absolute mb-0 ml-sm-2 text-left text-danger"
                                                    style={{fontSize: 13, bottom: '-20px'}}
                                                >
                                                    Invalid amount entered.
                                                </p>
                                                :
                                                    <span />
                                                }
                                            </label>
                                            <ToggleButtonGroup
                                                value={useSwapForm}
                                                onChange={handleInputSwap}
                                                aria-label="Swap"
                                                className="MS---Swap_button_toggle"
                                            >
                                                <ToggleButton value="true" aria-label="Swap" style={{broder:0,boxShadow:0}}>
                                                    <span class="material-icons">swap_vert</span>
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                            <div className="m-nt-2 mb-2" style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <p className="mb-0 d-inline-block">
                                                In-Game Coins
                                                </p>
                                                <p className="mb-0 d-inline-block">
                                                    Balance : {useUserInGameBalance}
                                                </p>
                                            </div>
                                            <label className="position-relative">
                                                <input 
                                                    type='number' 
                                                    placeholder="In-game amount"
                                                    value={useInGameAmount}
                                                    onChange={(event,type) =>handleMetaAmount(event,'inGameInput')}
                                                />
                                                {useInGameAmountError ? 
                                                <p 
                                                    className="position-absolute mb-0 ml-sm-2 text-left text-danger"
                                                    style={{fontSize: 13, bottom: '-20px'}}
                                                >
                                                    Invalid amount entered.
                                                </p>
                                                :
                                                    <span />
                                                }
                                            </label>
                                            {/* <input 
                                                type='number'
                                                placeholder="In-game amount"
                                                value={useInGameAmount} 
                                                onChange={(event,type) =>handleInGameAmount(event,'srch')}
                                            /> */}
                                            <div className="mt-3 mb-2 px-2" style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <p className="mb-0 d-inline-block" style={{fontSize: 12}}>
                                                    Price
                                                </p>
                                                <p className="mb-0 d-inline-block" style={{fontSize: 12}}>
                                                    {useInGameRate} per MetaSnooker
                                                </p>
                                            </div>
                                            { useApproveBTN ?
                                                <button
                                                    type="button"
                                                    className="MS---Neon--Button btn mt-4 mb-4 mr-3"
                                                    onClick={handleApprove}
                                                >
                                                    Approve
                                                </button>
                                            :
                                                <button 
                                                    type="button"
                                                    className="MS---Neon--Button btn mt-4 mb-4 mr-3"
                                                    onClick={ ( e ) => handleGetInGameSwap()}
                                                >
                                                    Get In-Game
                                                </button>
                                            }
                                        </form>
                                    }
                                </div>
                            </Grid>
                            <Grid
                                xs={12}
                                className="px-sm-4 text-center mt-0"
                            >
                                <div className="MS---dapp_form MS---dapp_card text-left mt-4">
                                    <h3 className="mb-0 px-5 py-3">Match History</h3>
                                    <TableContainer sx={{ maxHeight: 440 }} className="MS---dashboard-cards">
                                        <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                                >
                                                {column.label}
                                                </TableCell>
                                            ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {historyData}
                                        </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {/* <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={rows.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    /> */}
                                </div>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            xs={12}
                            lg={4}
                            alignContent="flex-start"
                            justifyContent="flex-start"
                            className="px-sm-4 pl-md-0 "
                        >
                            <Grid
                                container
                                xs={12}
                                className="MS---dapp_form MS---dapp_card text-left px-4 py-4 py-sm-4 my-4 my-lg-0"
                            >
                                {/* <Grid 
                                    xs={12}
                                    md={6}
                                    lg={12}
                                    ref={ref}
                                > */}
                                    {/* <h4 className="mb-4 mt-2">Your Daily Bet Volume</h4> */}
                                    {/* <img src={graph} className="img-fluid" /> */}
                                    {/* <div ref={ref}style={{width: '50%'}}>  */}
                                        {/* <BarChart 
                                            ylabel='Quantity'
                                            width={ref.current ? ref.current.offsetWidth : 0}
                                            height={300}
                                            margin={margin}
                                            data={data}
                                            style={{
                                                backgroundColor:'red'
                                            }}
                                            // onBarClick={this.handleBarClick}
                                        /> */}
                                    {/* </div> */}
                                {/* </Grid> */}
                                <Grid 
                                    container
                                    xs={12}
                                    lg={12}
                                >
                                    <Grid
                                        xs={12}
                                    >
                                        <h4 className="mb-4 mt-2 mt-sm-5 mt-md-2 mt-lg-5">Your Top Winnings</h4>
                                    </Grid>
                                    
                                    {topWiningTable}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            :
            <ConnectScreen 
                connectFun = {connectWallet}
            />
        }
        </div>
    );
}

export default DashboadScreen;